import _Api from '@/api/_Api';

import { SupplierResponse, SupplierSearchResponse } from '@/interfaces/Suppliers';

export class SuppliersApi extends _Api {
   static async get(id: number | string): Promise<SupplierResponse> {
      const response = await this.http().get(`suppliers/${id}`);
      return response.data;
   }

   static async activities(): Promise<SupplierSearchResponse[]> {
      const response = await this.http().get(`suppliers/activities`);
      return response.data;
   }

   static async create(supplier: SupplierResponse | any = {}): Promise<{ id: number }> {
      const response = await this.http().post(`suppliers`, supplier);
      return response.data;
   }

   static async duplicate(id: number | string): Promise<{ supplier: SupplierResponse }> {
      const response = await this.http().post(`suppliers/${id}/duplicate`);
      return response.data;
   }

   static async update(id: number | string, data: SupplierResponse): Promise<{ id: number }> {
      const response = await this.http().put(`suppliers/${id}`, data);
      return response.data;
   }

   static async archive(id: number | string) {
      const response = await this.http().put(`suppliers/${id}`, { 'change-state': 'archive' });
      return response.data;
   }

   static async unarchive(id: number | string) {
      const response = await this.http().put(`suppliers/${id}`, { 'change-state': 'unarchive' });
      return response.data;
   }

   static async all(params: any = { archive: false }): Promise<SupplierResponse[]> {
      const response = await this.http().get('suppliers', { params });
      return response.data;
   }
}
